export const GET_REWARD_OPTIONS_START = 'GET_REWARD_OPTIONS_START';
export const GET_REWARD_OPTIONS_FAIL = 'GET_REWARD_OPTIONS_FAIL';
export const GET_REWARD_OPTIONS_SUCCESS = 'GET_REWARD_OPTIONS_SUCCESS';

export const SEND_ITEM_START = 'SEND_ITEM_START';
export const SEND_ITEM_FAIL = 'SEND_ITEM_FAIL';
export const SEND_ITEM_SUCCESS = 'SEND_ITEM_SUCCESS';
